/**
 * SignOffEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { SignatureEntity } from "../SignatureEntity";
import { BugEntity } from "../BugEntity";
import { BugNoteEntity } from "../BugNoteEntity";
import { SignOffEntity } from "../SignOffEntity";
declare global {
    interface EntityTypeMap {
        SignOff: SignOffEntity;
    }
}
export abstract class SignOffGeneratedEntity extends BaseEntity {
    public abstract signOffId: string;
    public abstract companySignature: SignatureEntity | null;
    public abstract occupantSignature: SignatureEntity | null;
    public abstract bug: BugEntity;
    public abstract bugNote: BugNoteEntity | null;
}
